import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withStyles, Drawer, AppBar, Toolbar } from './../../../themes/default';
import { List, ListItem, ListItemIcon, ListItemText, ListSubheader } from './../../../themes/list';
import { DashboardIcon, PersonIcon, SubjectIcon, BookmarkIcon, ViewArrayIcon, ViewHeadlineIcon, DesktopMacIcon, CompareArrowsIcon, NotificationImportantIcon, PollIcon, NoteIcon, FileCopyIcon } from './../../../themes/icons';
import { hasPermission } from './../../../utilities/utils';

import CONSTANT from './../../../config/constant';

const styles = theme => ({
  root: {
    width: CONSTANT.sidebar.width,
    flexShrink: 0
  },
  paper: {
    width: CONSTANT.sidebar.width,
    borderRight: 'none',
    //background: 'none'
  },
  header: {
    boxShadow: theme.shadows[0]
  },
  menu: {
    //paddingLeft: theme.spacing.unit * 2,
    //paddingRight: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 3
  },
    menu__listItem: {
      //borderRadius: theme.spacing.unit / 2,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.body1.fontSize,
      paddingTop: theme.spacing.unit * 1,
      paddingBottom: theme.spacing.unit * 1,
      // borderTopRightRadius: theme.spacing.unit * 3,
      // borderBottomRightRadius: theme.spacing.unit * 3,
      marginBottom: 1,
      //borderLeft: `5px solid ${ theme.palette.grey[100] }`
      borderLeft: `5px solid ${ theme.palette.grey[100] }`,
      "&:hover" :{
        borderLeft: `5px solid ${ theme.palette.grey[400] }`,
      }
    },
      menu__listItem__icon: {
        color: theme.palette.primary.main
      },
      menu__listText: {
        color: theme.palette.grey[600]
      },
      menu__listItem__activeClass: {
        background: theme.palette.grey[100],
        borderLeft: `5px solid ${ theme.palette.primary.main }`
        // background: theme.palette.primary.light,
        // color:
      }
});

function renderItem(name, to, icon, classes, listOfPermissions, permission) {

  const needCheckPermissions = listOfPermissions && permission;

  return (
    ( (needCheckPermissions && hasPermission(listOfPermissions, permission)) || !needCheckPermissions) && (
      <ListItem
            button
            disableRipple
            component={ NavLink }
            to={ to }
            className={ classes.menu__listItem }
            activeClassName={ classes.menu__listItem__activeClass }>
        { icon && (
          <ListItemIcon className={ classes.menu__listItem__icon }>
            { icon }
          </ListItemIcon>
        )}
        <ListItemText primary={ name } disableTypography className={ classes.menu__listText } />
      </ListItem>
    )
  );

}

class Sidebar extends React.Component {

  constructor(props){
    super(props);
    this.state = {};
  }

  render() {

    const { classes } = this.props;
    const user = this.props.user.user ? this.props.user.user : null;
    const permissions = this.props.user.user ? this.props.user.user.permissions : null;

    return(
      <Drawer
          className={ classes.root }
          variant="permanent"
          classes={{
            paper: classes.paper
          }}>

          <AppBar position="static" className={ classes.header }>
            <Toolbar></Toolbar>
          </AppBar>
          <List component="ul" dense subheader={<ListSubheader>{ user.name } { user.surname }</ListSubheader>}>
            { renderItem( "Dashboard", "/dashboard", <DashboardIcon/> , classes ) }
            {/*
            { renderItem( "Categorías", "/categories", <PictureInPictureIcon/> , classes, permissions, 'CATEGORY_ALL' ) }
            { renderItem( "Páginas", "/pages", <PagesIcon/> , classes, permissions, 'PAGE_ALL' ) }
            */}
            { renderItem( "Destacados", "/featureds", <ViewArrayIcon/> , classes, permissions, 'FEATURED_ALL' ) }
            { renderItem( "Blog", "/blog", <SubjectIcon/> , classes, permissions, 'BLOG_ALL' ) }
            { renderItem( "Páginas", "/page-content", <SubjectIcon/> , classes, permissions, 'PAGE_CONTENT_ALL' ) }
            { renderItem( "Banners", "/banners", <ViewArrayIcon/> , classes, permissions, 'BANNERS_ALL' ) }
            { renderItem( "Productos", "/products", <BookmarkIcon/> , classes, permissions, 'PRODUCT_ALL' ) }
            { renderItem( "Alertas", "/alerts", <NotificationImportantIcon/> , classes, permissions, 'ALERT_ALL' ) }
            { renderItem( "CMDP", "/client-payment", <CompareArrowsIcon/> , classes, permissions, 'MEDIUM_PAYMENT_CHANGE' ) }
            { renderItem( "Autogestión", "/autogestion", <DesktopMacIcon/> , classes, permissions, 'AUTOGESTION_ALL' ) }
            { renderItem( "Encuestas", "/polls", <PollIcon/> , classes, permissions, 'POLL_ALL' ) }
            { renderItem( "Usuarios", "/users", <PersonIcon/> , classes, permissions, 'USER_ALL' ) }
            { renderItem( "Logs", "/logs", <ViewHeadlineIcon/> , classes, permissions, 'LOGS_ALL' ) }
            { renderItem( "Data", "/data", <NoteIcon/> , classes ) }
            { renderItem( "Polizas", "/policy", <FileCopyIcon/> , classes ) }
          </List>

          {/*
          <List component="ul" dense subheader={<ListSubheader>General</ListSubheader>}>
            { renderItem( "Dashboard", "/dashboard", <DashboardIcon/> , classes ) }
          </List>

          <List component="ul" dense subheader={<ListSubheader>Sitio Web</ListSubheader>}>
            { renderItem( "Categorías", "/categories", <PictureInPictureIcon/> , classes, permissions, 'CATEGORY_ALL' ) }
            { renderItem( "Páginas", "/pages", <PagesIcon/> , classes ) }
          </List>

          <List component="ul" dense subheader={<ListSubheader>Ventas</ListSubheader>}>
            { renderItem( "Productos", "/products", <BookmarkIcon/> , classes, permissions, 'PRODUCT_ALL' ) }
          </List>

          <List component="ul" dense subheader={<ListSubheader>Administración</ListSubheader>}>
            { renderItem( "Usuarios", "/users", <PersonIcon/> , classes, permissions, 'USER_ALL' ) }
          </List>
          */}

      </Drawer>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.User
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Sidebar));
